export enum InventoryPageTabs {
  AllEquipment = 'All Equipment',
}
